import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconActiveProps, IconRender } from '../types.ts';

const Menu = React.forwardRef<SVGSVGElement | null, IconActiveProps>(function Menu({ active, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21 6.25C21 6.52614 20.7761 6.75 20.5 6.75H3.5C3.22386 6.75 3 6.52614 3 6.25V5.75C3 5.47386 3.22386 5.25 3.5 5.25H20.5C20.7761 5.25 21 5.47386 21 5.75V6.25ZM21 12.25C21 12.5261 20.7761 12.75 20.5 12.75H3.5C3.22386 12.75 3 12.5261 3 12.25V11.75C3 11.4739 3.22386 11.25 3.5 11.25H20.5C20.7761 11.25 21 11.4739 21 11.75V12.25ZM21 18.25C21 18.5261 20.7761 18.75 20.5 18.75H3.5C3.22386 18.75 3 18.5261 3 18.25V17.75C3 17.4739 3.22386 17.25 3.5 17.25H20.5C20.7761 17.25 21 17.4739 21 17.75V18.25Z'
          fill={active ? 'transparent' : color}
        />
        {/* active */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21 6.25C21 6.52614 20.7761 6.75 20.5 6.75H3.5C3.22386 6.75 3 6.52614 3 6.25V5.75C3 5.47386 3.22386 5.25 3.5 5.25H20.5C20.7761 5.25 21 5.47386 21 5.75V6.25ZM18 12.25C18 12.5261 17.7761 12.75 17.5 12.75H3.5C3.22386 12.75 3 12.5261 3 12.25V11.75C3 11.4739 3.22386 11.25 3.5 11.25H17.5C17.7761 11.25 18 11.4739 18 11.75V12.25ZM21 18.25C21 18.5261 20.7761 18.75 20.5 18.75H3.5C3.22386 18.75 3 18.5261 3 18.25V17.75C3 17.4739 3.22386 17.25 3.5 17.25H20.5C20.7761 17.25 21 17.4739 21 17.75V18.25Z'
          fill={active ? color : 'transparent'}
        />
      </>
    ),
    [active],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'menu-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Menu;
